import { z } from "zod";

// Note: JsonValue type for hearAboutUs, usingUsFor, soloOrTeam, mostExcitedAbout
type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
const JsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema) as z.ZodType<JsonValue[]>,
    z.record(z.string(), JsonValueSchema) as z.ZodType<{ [key: string]: JsonValue }>
  ])
) as z.ZodType<JsonValue>;

export const Onboarding = z.object({
  id: z.string(),
  hearAboutUs: JsonValueSchema.nullable(),
  usingUsFor: JsonValueSchema.nullable(),
  soloOrTeam: JsonValueSchema.nullable(),
  mostExcitedAbout: JsonValueSchema.nullable(),
  completed: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  userId: z.string(),
  workspaceId: z.string().nullable(),
})
export type Onboarding = z.infer<typeof Onboarding>;